/** User-facing label for an in-flight tool call, e.g. `list_files` -> "Using list files…". */
export function toolActivityLabel(toolName: string): string {
  return `Using ${toolName.replace(/_/g, " ")}…`;
}
